// Profilo di destinazione di un contenuto.
//
// Alcuni clienti pubblicano su più profili dallo stesso piano editoriale
// (142 Restaurant: il ristorante e il Bistrot). Sulla scheda cliente si
// elencano i profili (`accountPubblicazione`), su ogni contenuto si segna per
// quale è pensato (`accountDestinazione`): tutti i profili = "Entrambi",
// vuoto = non indicato. Un cliente con un profilo solo non ha nulla da scegliere.

import { Cliente, Contenuto } from '../types';

export const dividiAccount = (testo: string): string[] =>
  Array.from(new Set(testo.split(',').map((a) => a.trim()).filter(Boolean)));

/** Profili fra cui scegliere: solo se il cliente ne ha almeno due */
export const accountDelCliente = (cliente?: Pick<Cliente, 'accountPubblicazione'> | null): string[] => {
  const account = cliente?.accountPubblicazione || [];
  return account.length >= 2 ? account : [];
};

/** Etichetta leggibile: il nome del profilo, "Entrambi"/"Tutti", o null se non indicato */
export const etichettaDestinazione = (
  contenuto: Pick<Contenuto, 'accountDestinazione'>,
  cliente?: Pick<Cliente, 'accountPubblicazione'> | null
): string | null => {
  const possibili = accountDelCliente(cliente);
  const scelti = (contenuto.accountDestinazione || []).filter((a) => possibili.includes(a));
  if (possibili.length === 0 || scelti.length === 0) return null;
  if (scelti.length === possibili.length) return possibili.length === 2 ? 'Entrambi' : 'Tutti i profili';
  return scelti.join(' + ');
};
